// extracted by mini-css-extract-plugin
export default {"wpapper":"Wpapper_wpapper__9ZNoj"};